import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { FareOptimisationService } from "libraries/service/fare-optimisation/fare-optimisation.service";
import { AirBookingResourceModule } from "libraries/service/resources/air-booking/air-booking-resource.module";

@NgModule({
    imports: [
        CommonModule,
        AirBookingResourceModule
    ],
    providers: [
        FareOptimisationService
    ],
})
export class FareOptimisationServiceModule {
}
